import { useCallback } from 'react';

import { useSetState } from './use-set-state.js';
import type { InternalSliceData } from '../../types/internal/pie-chart.js';

export const useSetVisibleSlicesState = () => {
  const setState = useSetState();

  const setVisibleSlicesState = useCallback(
    (slices: InternalSliceData[]) => {
      setState((prev) => {
        return {
          ...prev,
          visibleSlices: slices,
        };
      });
    },
    [setState],
  );

  return setVisibleSlicesState;
};
